import React from 'react';
import './ArtistDetailSkeleton.css';

function ArtistDetailSkeleton() {
  return (
    <div className="artist-detail-skeleton">
      <div className="skeleton-top">
        <div className="skeleton-breadcrumb"></div>
      </div>

      <div className="skeleton-profile-grid">
        <div className="skeleton-hero-image"></div>

        <div className="skeleton-profile">
          <div className="skeleton-profile-title"></div>
          <div className="skeleton-profile-subtitle"></div>
          <div className="skeleton-actions">
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
          <div className="skeleton-text-lines">
            <div className="skeleton-text-line"></div>
            <div className="skeleton-text-line"></div>
            <div className="skeleton-text-line short"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArtistDetailSkeleton;
